import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

import { IDoesFilterPassParams, IFilterParams, RowNode } from 'ag-grid-community';
import { IFilterAngularComp } from 'ag-grid-angular';
import { MAT_DATE_LOCALE } from '@angular/material/core';

@Component({
    selector: 'vias-date-cell',
    // template: `<input #filterText [value]="filterText" [ngModel]="filterText" (ngModelChange)="onChange($event)"/>`,
    template: `<div class="ag-input-wrapper custom-date-filter">
        <mat-select #dateRange [ngModel]="dateRangeValue"
            (ngModelChange)="onDateRangeChange($event)"
            panelClass="ag-custom-component-popup">
            <mat-option value="0">Tarih Aralığı</mat-option>
            <mat-option value="1">Bugün</mat-option>
            <mat-option value="-1">Dün</mat-option>
            <mat-option value="7">Bir Haftalık</mat-option>
            <mat-option value="30">Bu Ay</mat-option>
            <mat-option value="365">Bu Yıl</mat-option>
        </mat-select><br/>
        <input [matDatepicker]="dateStart" [value]="startDate">
        <mat-datepicker-toggle [for]="dateStart"></mat-datepicker-toggle>
        <mat-datepicker #dateStart
        panelClass="ag-custom-component-popup"></mat-datepicker><br/>
        <input [matDatepicker]="dateEnd" [value]="endDate">
        <mat-datepicker-toggle [for]="dateEnd"></mat-datepicker-toggle>
        <mat-datepicker #dateEnd
        panelClass="ag-custom-component-popup"></mat-datepicker>
    </div>`,
    styles: [
        `.custom-date-filter {
            padding:10px;
        }`
    ],
    providers: [{ provide: MAT_DATE_LOCALE, useValue: 'tr-TR' }]
})
export class DateFilterComponent implements IFilterAngularComp, AfterViewInit {
    private params: IFilterParams;
    private isLocalRefresh: boolean;
    public value = 0;
    public valueGetter;

    dateRangeValue = 0;
    startDate: Date = new Date();
    endDate: Date = new Date();

    @ViewChild('dateRange', { static: false }) public dateRange: ElementRef;
    @ViewChild('dateStart', { static: false }) public dateStart: ElementRef;
    @ViewChild('dateEnd', { static: false }) public dateEnd: ElementRef;

    agInit(params: IFilterParams): void {
        this.params = params;
        this.valueGetter = params.valueGetter;
        this.isLocalRefresh = params['isLocalRefresh'];
    }

    isFilterActive(): boolean {
        return this.startDate !== null && this.startDate !== undefined && this.startDate.getTime() !== 0;
    }

    doesFilterPass(params: IDoesFilterPassParams): boolean {
        if (this.isLocalRefresh) {
            const itemVal: number = Number.parseInt(this.valueGetter(params.node), 10);
            return (itemVal > this.startDate.getTime() / 1000
                && itemVal < this.endDate.getTime() / 1000);
            // return this.value.toLowerCase()
            // .split(' ')
            // .every((filterWord) => {
            //     return this.valueGetter(params.node).toString().toLowerCase().indexOf(filterWord) >= 0;
            // });
        } else {
            //  db ye gidecek. hep true gelmesi lazim...
            return true;
        }
    }

    getModel(): any {
        return { value: this.value };
    }

    setModel(model: any): void {
        this.value = model ? model.value : '';
    }

    ngAfterViewInit(): void {
        window.setTimeout(() => {
            // this.dateRange.nativeElement.classList.add('ag-custom-component-popup');
            //   this.dateRange.nativeElement.value = this.value;
        });
    }

    onDateRangeChange(val): void {
        switch (Number.parseInt(val, 10)) {
            default:
            case 0:
                this.startDate.setHours(0, 0, 0, 0);
                this.endDate.setHours(23, 59, 59, 999);
                break;
            case -1:
                this.startDate = new Date();
                this.startDate.setDate(this.startDate.getDate() - 1);
                this.startDate.setHours(0, 0, 0, 0);
                this.endDate = new Date();
                this.endDate.setDate(this.endDate.getDate() - 1);
                this.endDate.setHours(23, 59, 59, 999);
                break;
            case 1:
                this.startDate = new Date();
                this.startDate.setHours(0, 0, 0, 0);
                this.endDate = new Date();
                this.endDate.setHours(23, 59, 59, 999);
                break;
            case 7:
                this.startDate = new Date();
                this.startDate.setDate(this.startDate.getDate() - 7);
                this.startDate.setHours(0, 0, 0, 0);
                this.endDate = new Date();
                this.endDate.setHours(23, 59, 59, 999);
                break;
            case 30:
                this.startDate = new Date();
                this.startDate = new Date(
                    this.startDate.getFullYear(), this.startDate.getMonth(), 1, 0, 0, 0, 0);
                this.endDate = new Date();
                this.endDate = new Date(
                    this.endDate.getFullYear(), this.endDate.getMonth() + 1, 0, 23, 59, 59, 999);
                break;
            case 365:
                this.startDate = new Date();
                this.startDate = new Date(
                    this.startDate.getFullYear(), 0, 1, 0, 0, 0, 0);
                this.endDate = new Date();
                this.endDate = new Date(
                    this.endDate.getFullYear(), 11, 31, 23, 59, 59, 999);
                break;
        }
        this.params.filterChangedCallback();
    }
    // onChange(newValue): void {
    //     if (this.value !== newValue) {
    //         this.value = newValue;
    //         this.params.filterChangedCallback();
    //     }
    // }
}
